import StatusHandler from 'app/shared-components/StatusHandler'
import FormWithControls from 'app/shared-components/FormWithControls'
import requests from 'app/requests/BillingCompany.requests'
import useEnumValues from 'app/hooks/useEnumValues'
import useFieldsWithClassName from 'app/hooks/useFieldsWithClassName'

import useGetBillingCompany from '../hooks/useGetBillingCompany'
import useStyles from './salesAreaTax.styles'
import getFields from './salesAreaTax.fields'

const SalesAreaTax = ({
    id,
}: { id: number }) => {
    const {
        classes,
    } = useStyles()

    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetBillingCompany(id)

    const getAllowedValues = useEnumValues()

    const fields = useFieldsWithClassName(getFields(getAllowedValues), classes)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <FormWithControls
                name="SalesAreaTab"
                value={data}
                onSuccess={invalidate}
                fields={fields}
                requestParams={requests.salesAreaTax({
                    id,
                })}
                exists
            />
        </StatusHandler>
    )
}

export default SalesAreaTax
